import React from 'react';
import './TAnimation.scss';

const TAnimation = () => {
  return (
    <div>
      <div className='svg-container t'>
        <svg viewBox='0 0 250 250'>
          <g className='follow'>
            <polygon
              className='t-follow-c2'
              stroke='#DD07F4'
              points='115 86 115 164.050007 92.5 177.007625 92.5 100 69.999 113.5 69.999 86 137.49775 47 137.49525 73.136375'
            ></polygon>
            <polygon
              className='t-follow-c1'
              stroke='#DD07F4'
              points='160 112.148498 115 86 115 164.087505 160 190.015998'
            ></polygon>
            <polygon
              className='t-follow-b3'
              stroke='#4407F4'
              points='137.497375 125.196126 92.5 100 92.5 177.047376 137.497375 203.162376'
            ></polygon>
            <polygon
              className='t-follow-b2'
              stroke='#4407F4'
              points='115 112.090875 69.998625 86.127125 69.998625 113.5 115 138.095001'
            ></polygon>
            <polygon
              className='t-follow-b1'
              stroke='#4407F4'
              points='115 112 70 86 137.5 47 182.5 73'
            ></polygon>
            <polygon
              className='t-follow-a'
              stroke='#4407F4'
              points='160 112.111 160 189.9785 137.497625 203.12225 137.497625 125.156 115 138.09475 115 112.091 182.497625 73.13725 182.497625 98.93475'
            ></polygon>
          </g>
          <g className='start'>
            <polygon
              className='t-start-c2'
              stroke='#fc8a68'
              points='115 86 115 164.050007 92.5 177.007625 92.5 100 69.999 113.5 69.999 86 137.49775 47 137.49525 73.136375'
            ></polygon>
            <polygon
              className='t-start-c1'
              stroke='#fc8a68'
              points='160 112.148498 115 86 115 164.087505 160 190.015998'
            ></polygon>
            <polygon
              className='t-start-b3'
              stroke='#fc8a68'
              points='137.497375 125.196126 92.5 100 92.5 177.047376 137.497375 203.162376'
            ></polygon>
            <polygon
              className='t-start-b2'
              stroke='#fc8a68'
              points='115 112.090875 69.998625 86.127125 69.998625 113.5 115 138.095001'
            ></polygon>
            <polygon
              className='t-start-b1'
              stroke='#fc8a68'
              points='115 112 70 86 137.5 47 182.5 73'
            ></polygon>
            <polygon
              className='t-start-a'
              stroke='#fc8a68'
              points='160 112.111 160 189.9785 137.497625 203.12225 137.497625 125.156 115 138.09475 115 112.091 182.497625 73.13725 182.497625 98.93475'
            ></polygon>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default TAnimation;
